import React from 'react'
import TextField from '@material-ui/core/TextField'
import { PeopleSharp } from '@material-ui/icons'

const CustomInput = (props) => {
    const shrink = props.shrink ? props.shrink.toString() : 'false'
    return (
        <div className="customInput">
            {/* <label>{props.label}*</label> */}
            <TextField
                defaultValue={props.defaultValue}
                value={props.value}
                autoFocus={props.autoFocus}
                name={props.name}
                onChange={props.onChange || props.onChange}
                onBlur={props.onBlur || props.onBlur}
                onKeyDown={props.onKeyDown || props.onKeyDown}
                InputProps={{
                    inputProps: props.inputProps,
                    startAdornment: props.startadornment,
                    endAdornment: props.endadornment,
                    shrink: shrink,
                }}
                id={props.id}
                label={props.label}
                type={props.type}
                size={props.size}
                disabled={props.disabled}
                variant="filled"
                placeholder={props.placeholder}
                error={props.error}
                helperText={props.helperText}
                {...props}
            />
        </div>
    )
}

export default CustomInput
